import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";

interface IHoveredTimeProps {
  setHoveredTime: any;
  start: () => void;
  isAnimating: boolean;
}

/**
 * A dumb component to keep timelineGL up-to-date on the current value time that is hovered
 * @param timelineGL -
 * @param start -
 * @param isAnimating -
 * @returns  null
 */
export const HoveredTime = (props: IHoveredTimeProps): null => {
  const { setHoveredTime, isAnimating, start } = props;

  const hoveredTime: number = useSelector((state: IRootState) => state.timelineFlights.hoveredTime);

  useEffect(() => {
    if (setHoveredTime) {
      setHoveredTime(hoveredTime);
    }
    if (!isAnimating) {
      start();
    }
  }, [setHoveredTime, hoveredTime, isAnimating, start]);

  return null;
};
